import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './theme/shared/shared.module';

import { AppComponent } from './app.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
import { NavSearchComponent } from './theme/layout/admin/nav-bar/nav-left/nav-search/nav-search.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import {ChatUserListComponent} from './theme/layout/admin/nav-bar/nav-right/chat-user-list/chat-user-list.component';
import {FriendComponent} from './theme/layout/admin/nav-bar/nav-right/chat-user-list/friend/friend.component';
import {ChatMsgComponent} from './theme/layout/admin/nav-bar/nav-right/chat-msg/chat-msg.component';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';

import { ToggleFullScreenDirective } from './theme/shared/full-screen/toggle-full-screen';
import {ArchwizardModule} from 'angular-archwizard';

/* Menu Items */
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { NgbAccordionModule, NgbButtonsModule, NgbCollapseModule, NgbDropdownModule, NgbPaginationModule, NgbTabsetModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './page/login/login.component';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { ToastrModule } from 'ngx-toastr';
import { TextMaskModule } from 'angular2-text-mask';
import { NgNumberFormatterModule } from 'ng-number-formatter';
import { FullTextSearchPipe } from './shared/filter.pipe';
import { SanitizeHtmlPipe } from './shared/sanitize.pipe';
import { LoggedInGuard } from './page/security/loggedin.quard';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ColorPickerModule } from 'ngx-color-picker';
import { HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './page/home/home.component';
import { TinymceModule } from 'angular2-tinymce';
import { CadastroUsuarioComponent } from './page/cadastro-usuario/cadastro-usuario.component';
import { SelectModule } from 'ng-select';
import { TagInputModule } from 'ngx-chips';
import { DragulaModule, DragulaService } from 'ng2-dragula';
import { SelectOptionService } from './theme/shared/components/select/select-option.service';
import { BarRatingModule } from 'ngx-bar-rating';
import { AvisoComponent } from './page/aviso/aviso.component';
import { DataTablesModule } from 'angular-datatables';
import { NgxTreeDndModule } from 'ngx-tree-dnd';
import { CadastroEmpresaComponent } from './page/cadastro-empresa/cadastro-empresa.component';
import { ListEmpresaComponent } from './page/list-empresa/list-empresa.component';
import { CadastroProgramaComponent } from './page/cadastro-programa/cadastro-programa.component';
import { ListProgramaComponent } from './page/list-programa/list-programa.component';
import { DocumentosComponent } from './page/documentos/documentos.component';
import { AlertaEmpresaComponent } from './page/alerta-empresa/alerta-empresa.component';
import { ListaProgramaEmpresaComponent } from './page/lista-programa-empresa/lista-programa-empresa.component';
import { VerDocumentosEmpresaComponent } from './page/ver-documentos-empresa/ver-documentos-empresa.component';
import { EtapasComponent } from './page/etapas/etapas.component';
import { ArtigoComponent } from './page/artigo/artigo.component';
import { JornadaComponent } from './page/jornada/jornada.component';
import { NotificacaoComponent } from './page/notificacao/notificacao.component';
import { PedidosComponent } from './page/pedidos/pedidos.component';
import { PedidoFilterPipe } from './shared/pipes/pedido-filter.pipe';
import { ProdutosComponent } from './page/produtos/produtos.component';
import { ProdutoFilterPipe } from './shared/pipes/produto-filter.pipe';
import { ClienteComponent } from './page/cliente/cliente.component';
import { CampanhaComponent } from './page/campanha/campanha.component';

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthComponent,
    NavigationComponent,
    NavContentComponent,
    NavGroupComponent,
    NavCollapseComponent,
    NavItemComponent,
    NavBarComponent,
    NavLeftComponent,
    NavSearchComponent,
    NavRightComponent,
    ChatUserListComponent,
    FriendComponent,
    ChatMsgComponent,
    ConfigurationComponent,
    ToggleFullScreenDirective,
    LoginComponent,
    HomeComponent,
    FullTextSearchPipe,
    SanitizeHtmlPipe,
    CadastroUsuarioComponent,
    AvisoComponent,
    CadastroEmpresaComponent,
    ListEmpresaComponent,
    CadastroProgramaComponent,
    ListProgramaComponent,
    DocumentosComponent,
    AlertaEmpresaComponent,
    ListaProgramaEmpresaComponent,
    VerDocumentosEmpresaComponent,
    EtapasComponent,
    ArtigoComponent,
    JornadaComponent,
    NotificacaoComponent,
    PedidosComponent,
    PedidoFilterPipe,
    ProdutosComponent,
    ProdutoFilterPipe,
    ClienteComponent,
    CampanhaComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    TextMaskModule,
    SharedModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbButtonsModule,
    NgbTabsetModule,
    NgbModalModule,
    FileUploadModule,
    NgxSpinnerModule,
    NgbCollapseModule,
    NgbAccordionModule,
    ArchwizardModule,
    NgNumberFormatterModule,
    BarRatingModule,
    NgbPaginationModule,
    DataTablesModule,
    DragulaModule.forRoot(),
    ToastrModule.forRoot(),
    NgxTreeDndModule,
    NgbModule.forRoot(),
    SelectModule,
    TagInputModule
  ],
  providers: [NavigationItem, LoggedInGuard, DragulaService, SelectOptionService],
  bootstrap: [AppComponent]
})
export class AppModule { }
